export default "__VITE_ASSET__ye0ld2X5__"